<template>
  <div>
    <h1 class="text-xs-center">Business Client Detail</h1>
    <v-card class="mt-3">
      <businesslist_client />
    </v-card>
  </div>
</template>

<script>
import businesslist_client from "@/components/back-office/Business/business-client.vue";
import { mapState } from "vuex";
export default {
  components: {
    businesslist_client,
  },
};
</script>
